<section class="legal-page" aria-label="Klauzula RODO">
  <header class="legal-header">
    <p class="legal-tag">Dokument prawny</p>
    <h1>Klauzula informacyjna RODO</h1>
    <p>
      Poniżej przedstawiamy podstawowe informacje o przetwarzaniu danych osobowych
      zgodnie z Rozporzadzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 (RODO).
    </p>
  </header>

  <article class="legal-card">
    <h2>1. Administrator danych</h2>
    <p>
      Administratorem danych osobowych jest Waldemar Grzechnik,
      ul. Obozowa 41/45, 30-383 Krakow.
    </p>

    <h2>2. Cele przetwarzania danych</h2>
    <p>Dane osobowe przetwarzamy w celu:</p>
    <ul>
      <li>obslugi zapytan i kontaktu z pacjentami/opiekunami,</li>
      <li>organizacji i realizacji uslug weterynaryjnych,</li>
      <li>analizy ruchu na stronie, statystyk odwiedzin i poprawy funkcjonowania serwisu,</li>
      <li>zapewnienia bezpieczenstwa teleinformatycznego serwisu,</li>
      <li>ochrony przed nadużyciami i roszczeniami.</li>
    </ul>

    <h2>3. Podstawy prawne</h2>
    <p>
      Podstawami prawnymi przetwarzania danych sa:
      art. 6 ust. 1 lit. b, c oraz f RODO.
    </p>

    <h2>4. Kategorie danych</h2>
    <p>
      Przetwarzane moga byc dane identyfikacyjne i kontaktowe przekazane przez Panstwa,
      a takze dane techniczne wynikajace z korzystania z serwisu (logi serwerowe).
    </p>

    <h2>5. Odbiorcy danych</h2>
    <p>
      Odbiorcami danych moga byc podmioty wspierajace administratora
      w obsludze IT, hostingu i utrzymaniu serwisu, na podstawie stosownych umow.
    </p>

    <h2>6. Czas przechowywania danych</h2>
    <p>
      Dane sa przechowywane przez okres niezbedny do realizacji celow przetwarzania,
      a logi techniczne do 5 lat.
    </p>

    <h2>7. Prawa osoby, ktorej dane dotycza</h2>
    <p>Przysluguje Panstwu prawo do:</p>
    <ul>
      <li>dostepu do danych,</li>
      <li>sprostowania danych,</li>
      <li>usuniecia danych (w przypadkach przewidzianych prawem),</li>
      <li>ograniczenia przetwarzania,</li>
      <li>sprzeciwu wobec przetwarzania,</li>
      <li>wniesienia skargi do Prezesa UODO.</li>
    </ul>
    <p>
      Powyższe prawa nie obejmuja logow technicznych serwera w zakresie, w jakim ich
      przechowywanie jest niezbedne dla zapewnienia bezpieczenstwa, prawidlowej
      administracji serwisu oraz dochodzenia lub obrony przed roszczeniami.
    </p>

    <h2>8. Informacja o cookies i logach</h2>
    <p>
      Serwis korzysta z niezbednych mechanizmow technicznych wymaganych do poprawnego
      dzialania uslugi www. Po wyrazeniu zgody moze takze korzystac z cookies i podobnych
      technologii analitycznych, w tym narzedzi Google Analytics, aby mierzyc ruch na stronie,
      analizowac sposob korzystania z serwisu, rodzaj urzadzenia, przegladarke, przyblizona
      lokalizacje, zrodlo wejscia, odwiedzane podstrony, czas spędzony w serwisie oraz ogolne
      interakcje z trescia, a takze ulepszac jego tresci i funkcjonalnosc.
      W celach bezpieczenstwa i utrzymania uslugi zapisywane sa takze logi serwerowe,
      obejmujace dane techniczne ruchu.
    </p>

    <h2>9. Kontakt</h2>
    <p>
      W sprawach danych osobowych kontakt z administratorem na adres:
      Waldemar Grzechnik, ul. Obozowa 41/45, 30-383 Krakow.
    </p>
  </article>

  <p class="legal-back">
    <a routerLink="/">Wroc do strony glownej</a>
  </p>
</section>
